<template>
  <div>
    <!-- NOTIFICATIONS -->
    <vs-dropdown vs-custom-content class="cursor-pointer">
      <feather-icon
        icon="BellIcon"
        class="cursor-pointer mt-1 sm:mr-6 mr-2"
        :badge="unreadCount"
      />

      <vs-dropdown-menu
        class="notification-dropdown dropdown-custom vx-navbar-dropdown"
      >
        <div class="notification-tops p-5 text-center bg-primary text-white">
          <h3 class="text-white">お知らせ</h3>
        </div>

        <component
          :is="scrollbarTag"
          ref="mainSidebarPs"
          class="scroll-area--nofications-dropdown p-0 mb-10"
          :settings="settings"
          :key="$vs.rtl"
          @ps-x-reach-end="scrollHandle"
        >
          <ul class="bordered-items">
            <li
              v-for="nt in unreadNotifications"
              :key="nt.id"
              class="flex justify-between px-4 py-4 notification cursor-pointer"
              @click="showDetail(nt.id)"
            >
              <div class="flex items-start content">
                <div
                  v-show="!nt.read_at"
                  class="h-1 w-1 mt-6 rounded-full bg-primary"
                ></div>
                <div class="mx-2 ml-2">
                  <span class="font-medium block notification-title">{{
                    nt.title
                  }}</span>
                  <p>{{ nt.content }}</p>
                </div>
              </div>
              <small class="mt-1 whitespace-no-wrap">{{
                elapsedTime(nt.created_at)
              }}</small>
            </li>
          </ul>
        </component>

        <div
          class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer"
          @click="toNotificationList"
        >
          <span>通知一覧で見る</span>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { createNamespacedHelpers } from "vuex";
import { DateUtil } from "@/utils";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers(
  "notification"
);

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      popupActive: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
        suppressScrollX: true
      },
      notificationId: null,
      showDialog: false,
      dialogSettings: {
        title: "",
        content: "",
        isRead: false
      }
    };
  },
  computed: {
    ...mapState({
      unreadNotifications: state => state.unreadNotifications,
      notifications: state => state.notifications,
      unreadCount: state => state.unreadCount,
      pageable: state => state.pageable,
      hasNext: state => state.hasNext
    }),

    ...mapGetters(["getNotification"]),

    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    ...mapActions([
      "fetchUnreadNotifications",
    ]),
    toNotificationList() {
      this.$router
        .push({
          name: "notification-list-all"
        })
        .catch(() => {});
    },
    showDetail(notificationId) {
      this.$router.push({ name: "notification-list-all", query: { notificationId: notificationId } })
    },
    status(val) {
      return val === null;
    },
    async close() {
      if (this.dialogSettings.isRead) {
        return;
      }
      await this.readeNotifications(this.notificationId);
      this.fetchNotifications();
    },
    scrollHandle() {},
    elapsedTime(startTime) {
      return DateUtil.elapsedTime(startTime);
    }
  },
  created() {
    // this.$setInterval(() => {
    //   authService
    //     .renewToken()
    //     .then(() => {
    //       return authService.getIdToken();
    //     })
    //     .then(t => {
    //       let payload = {
    //         idToken: t
    //       };
    //       Vue.$log.info("== Refresh Token by Timer ==");
    //       this.$store.commit("SET_ID_TOKEN", payload);
    //       this.fetchUnreadNotifications()
    //     });
    //   Vue.$log.info("== Update Notifications ==")
    // }, 1800000);
  }
};
</script>

<style lang="scss">
.content {
  overflow: hidden;
  .mx-2 {
    text-align: left;
  }
  span {
    font-size: initial;
    font-weight: bold;
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  p {
    font-size: small;
    font-weight: lighter;
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
